import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { IFileUpload } from '../constants/models';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    constructor() { }
    isNullOrUndefined(value: string) {
        try {
            return value === undefined || value === '' || value === null ? true : false;
        } catch (error) {
            console.log('isNullOrUndefined', error);
        }
    }

    private changeFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    uploadFile(event) {
        return new Observable((subscriber) => {
            try {
                const result: IFileUpload = { base64: null, file_type: null };
                if (event.target.value) {
                    const file = event.target.files[0];
                    result.file_type = file.name.split('.')[1];
                    this.changeFile(file).then((base64: string): any => {
                        base64 = base64.replace('data:application/pdf;base64,', '')
                        base64 = base64.replace('data:image/jpeg;base64,', '')
                        result.base64 = base64;
                        subscriber.next(result);
                    });
                }
            } catch (error) {
                subscriber.next(null);
            }

        });
    }

}
